class YsSlideshow extends HTMLElement {
  connectedCallback() {
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.slideCount = this.querySelectorAll('.swiper-slide').length;
    this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slideCount > 1;

    const paginationEl = this.querySelector('.ys-slideshow__pagination');
    const prevEl = this.querySelector('.ys-slideshow__nav--prev');
    const nextEl = this.querySelector('.ys-slideshow__nav--next');
    const isCentered = this.dataset.layout === 'centered';
    // Swiper's loop + centeredSlides can't correctly wrap when the slide count
    // is too low to provide a real slide beyond what's simultaneously visible
    // (prev + active + next). Below that, fall back to a bounded (non-looping)
    // carousel so the edges show a real boundary instead of a blank peek.
    const canLoopCentered = this.slideCount >= 5;

    this.swiper = new Swiper(this, {
      effect: 'slide',
      ...(isCentered ? { centeredSlides: true, slidesPerView: 'auto', spaceBetween: 10 } : {}),
      loop: this.dataset.loop === 'true' && (!isCentered || canLoopCentered),
      speed: 600,
      watchOverflow: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : false,
      autoplay: this.shouldAutoplay()
        ? {
            delay: Number(this.dataset.autoplayDelay) || 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
    });

    this.videos = Array.from(this.querySelectorAll('.ys-slideshow__video'));
    this.updateVideos();

    this.reducedMotion.addEventListener('change', this.updateAutoplay.bind(this));
    this.reducedMotion.addEventListener('change', this.updateVideos.bind(this));

    if (window.Shopify && window.Shopify.designMode) {
      this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this));
    }
  }

  onBlockSelect(event) {
    const slide = event.target.closest('.ys-slideshow__slide');
    if (!slide || !this.contains(slide)) return;
    const internalIndex = Array.from(this.swiper.slides).indexOf(slide);
    if (internalIndex === -1) return;
    this.swiper.autoplay.stop();
    this.swiper.slideTo(internalIndex, 0);
  }

  onBlockDeselect() {
    this.updateAutoplay();
  }

  shouldAutoplay() {
    return this.autoplayEnabled && !this.reducedMotion.matches;
  }

  updateAutoplay() {
    if (!this.swiper) return;
    if (this.shouldAutoplay()) {
      this.swiper.autoplay.start();
    } else {
      this.swiper.autoplay.stop();
    }
  }

  updateVideos() {
    const playVideos = !this.reducedMotion.matches;
    this.videos.forEach((video) => {
      video.classList.toggle('is-active', playVideos);
      if (playVideos) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) this.swiper.destroy(true, true);
    this.videos.forEach((video) => video.pause());
  }
}

customElements.define('ys-slideshow', YsSlideshow);
